import React, { Fragment, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useProfile } from '../context/ProfileContext';
import { useApiErrorHandler } from '../hooks/useApiErrorHandler';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const auth = useAuth();
  const { isLoading: profileLoading } = useProfile();
  const navigate = useNavigate();

  useApiErrorHandler((message) => {
    setFormError(`Falha ao fazer login: ${message}`);
    return true;
  });

  // Redireciona após login baseado nas regras de perfil
  useEffect(() => {
    if (!auth?.token || profileLoading) return;
    navigate('/home', { replace: true });
  }, [auth?.token, profileLoading, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFormError('');
    try {
      if (!auth || !auth.login) {
        throw new Error('Auth context not available');
      }
      await auth.login(email, password);
    } catch (err: any) {
      const msg = err?.graphQLErrors?.[0]?.message ?? err?.message ?? 'Erro ao fazer login.';
      setFormError(msg);
    }
  };



  return (
    <Fragment>
      <div className="main-wrap">
        <div className="nav-header bg-transparent shadow-none border-0">
          <div className="nav-top w-100">
            <Link to="/" className='ms-5 mt-5'>
              <img src="/assets/images/logo-inplay.png" alt="InPlay Logo" className="nav-logo" style={{ height: 60 }} />
            </Link>
            <button className="nav-menu me-0 ms-auto"></button>
            <Link to="/login" className="header-btn d-none d-lg-block bg-dark fw-500 text-white font-xsss p-3 ms-auto w100 text-center lh-20 rounded-xl">Login</Link>
            <Link to="/register" className="header-btn d-none d-lg-block bg-current fw-500 text-white font-xsss p-3 ms-2 w100 text-center lh-20 rounded-xl">Cadastrar</Link>
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-5 d-none d-xl-block p-0 vh-100 bg-image-contain bg-no-repeat bg-primary"
            style={{
              backgroundImage: `url("assets/images/login-banner.png")`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'contain'
            }}
          ></div>
          <div className="col-xl-7 vh-100 align-items-center d-flex bg-white rounded-3 overflow-hidden">
            <div className="card shadow-none border-0 ms-auto me-auto login-card">
              <div className="card-body rounded-0 text-left">
                <h2 className="fw-700 display1-size display2-md-size mb-3">Entre na <br />sua conta</h2>
                <form onSubmit={handleSubmit}>
                  {formError && (
                    <p className="text-danger mb-3">{formError}</p>
                  )}
                  <div className="form-group icon-input mb-3">
                    <i className="font-sm ti-email text-grey-500 pe-0"></i>
                    <input
                      type="text"
                      className="style2-input ps-5 form-control text-grey-900 font-xsss fw-600"
                      placeholder="Usuário ou e-mail"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      data-testid="login-email"
                    />
                  </div>
                  <div className="form-group icon-input mb-1">
                    <input
                      type={showPassword ? "text" : "password"}
                      className="style2-input ps-5 form-control text-grey-900 font-xss ls-3"
                      placeholder="Senha"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      data-testid="login-password"
                    />
                    <i className="font-sm ti-lock text-grey-500 pe-0"></i>
                     <i
                        className={`bi ${showPassword ? "bi-eye-slash" : "bi-eye"}`}
                        style={{
                          position: "absolute",
                          left: "90%",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          zIndex: 2,
                          fontSize: 18,
                          color: "#888",
                          width: 20,
                        }}
                        onClick={() => setShowPassword((v) => !v)}
                        title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                      ></i>
                  </div>
                  <div className="form-check text-left mb-3">
                    {/* <input type="checkbox" className="form-check-input mt-2" id="exampleCheck5" />
                    <label className="form-check-label font-xsss text-grey-500">Lembrar-me</label> */}
                    <Link to="/forgot-request" className="fw-600 font-xsss text-primary mt-1 float-right">Esqueci minha senha</Link>
                  </div>
                  <div className="form-group mb-1">
                    <button type="submit" className="btn btn-primary form-control text-center style2-input fw-600 border-0 p-0 fs-5" data-testid="login-submit">
                      Entrar
                    </button>
                  </div>
                </form>
                <div className="col-sm-12 p-0 text-left">
                  <h6 className="text-grey-500 font-xsss fw-500 mt-0 mb-0 lh-32">
                    Não possui uma conta? <Link to="/register" className="fw-700 ms-1">Registre-se</Link>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Login;
